import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "../../ppui";
import {
  ContentHeading,
  ContentLayout,
  ContentWrapper,
  ContentMenu,
  ContentForm,
} from "../style";
import { Outlet } from "react-router-dom";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import { TbDevicesDollar, TbPasswordUser, TbUserScan, TbWorldPin } from "react-icons/tb";
import useLeavePolicyService from "./leave-policy-service";
import { MdOutlineHolidayVillage } from "react-icons/md";

function OrganizationalLeavePolicy() {
  const { employmentType } = useLeavePolicyService();

  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      icon: <TbDevicesDollar />,
      primaryText: "Full-time Employees",
      path: "full-time-employees",
      key: "full_time",
    },
    {
      icon: <TbPasswordUser />,
      primaryText: "Probationary Employees",
      path: "probationary-employees",
      key: "probationary",
    },
    {
      icon: <TbWorldPin />,
      primaryText: "Part-time Employees",
      path: "part-time-employees",
      key: "part_time",
    },
    {
      icon: <TbUserScan />,
      primaryText: "Contractual Employees",
      path: "contractual-employees",
      key: "contractual",
    }
  ];

  const filteredMenuItems = menuItems.filter((item) => employmentType.includes(item.key));

  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Leave Policy
          </Typography>
        </ContentHeading>

        <ContentWrapper>
          <ContentMenu>
            <List
              size={"md"}
              color={"default"}
              activeColor={"default"}
              Colorvariant={"dark"}
              hover={"secondary"}
              gap={15}
            >
              <ListItem
                onClick={() => navigate("/leave-policy")}
                className={location.pathname === "/leave-policy" ? "active" : ""}
                colorVariant="light"
                isActive={location.pathname === "/leave-policy"}
              >
                <ListIcon>
                  <MdOutlineHolidayVillage />
                </ListIcon>
                <ListText primary={"Weekly Off"} />
              </ListItem>
              {filteredMenuItems.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => navigate(item.path)}
                  className={location.pathname === item.path ? "active" : ""}
                  colorVariant="light"
                  isActive={location.pathname === item.path}
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
              
            </List>
          </ContentMenu>
          <ContentForm>
            <Outlet />
          </ContentForm>
        </ContentWrapper>
      </ContentLayout>
    </>
  );
}

export default OrganizationalLeavePolicy;
